// Taken from district-bloom version 0.12.1

import React, { useEffect, useRef } from "react";
import {
  Animated,
  Easing,
  StyleSheet,
  TouchableWithoutFeedback,
} from "react-native";

import { BMPrimitives, useBMTheme } from "@traveloka/district-bloom";

type BMOverlayProps = {
  dismissible?: boolean;
  testID?: string;
  visible: boolean;
  onDismiss?: () => void;
  opacity?: number;
};

const BMOverlay = (props: BMOverlayProps) => {
  const {
    dismissible = true,
    testID,
    visible,
    onDismiss,
    opacity = 0.6,
  } = props;
  const overlayOpacityAnimation = useRef(new Animated.Value(0)).current;
  const { BMComponents } = useBMTheme();

  const overlayOpacityInterpolation = overlayOpacityAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: [0, opacity],
  });

  const handleOpen = () => {
    const { easeInOut } = BMPrimitives.BMAnimation.transition;

    Animated.timing(overlayOpacityAnimation, {
      toValue: 1,
      duration: 400,
      useNativeDriver: false,
      easing: Easing.bezier(
        easeInOut.x1,
        easeInOut.y1,
        easeInOut.x2,
        easeInOut.y2
      ),
    }).start();
  };

  const handleClose = () => {
    const { x1, y1, x2, y2 } = BMPrimitives.BMAnimation.transition.easeInOut;
    Animated.timing(overlayOpacityAnimation, {
      toValue: 0,
      duration: 200,
      useNativeDriver: false,
      easing: Easing.bezier(x1, y1, x2, y2),
    }).start();
  };

  useEffect(() => {
    if (visible) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [visible]);

  return (
    <TouchableWithoutFeedback
      onPress={
        dismissible
          ? () => {
              handleClose();
              onDismiss?.();
            }
          : () => null
      }
    >
      <Animated.View
        style={[
          styles.overlay,
          {
            backgroundColor: BMComponents.BMStyleOverlaysScrim,
            opacity: overlayOpacityInterpolation,
          },
        ]}
        testID={`${testID}-overlay`}
      />
    </TouchableWithoutFeedback>
  );
};

export default BMOverlay;

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
  },
});
